<template>
	<div :class="'scroll-content-section '+type" :style="additionalStyleSectionContent">
		<div :class="`scroll-content-text stack-vertical ${sizeContentText}`" v-html="utils.markdownToHtml(caption)"></div>
	</div>
</template>

<script type="text/javascript">
import { gsap, Power1 } from "gsap/dist/gsap.min.js";
import { mapGetters } from 'vuex';
import utils from '@js/utils.js';
import API from '@js/API.js';
import cloneDeep from 'lodash.clonedeep';

export default {
	name: 'InterfaceSectionContent',
	props: {
		id: {
			type: String,
		},
		visible: {
			type: Boolean,
			default: false 
		},
		type: {
			type: String,
			default: 'left'
		},
		buttonPosition: {
			type: String,
			default: 'left'
		},
		remarkablePoints: {
			type: Array
		},
		inDepthContent: {
			type: Object
		},
		showInDepthButton: {
			type: Boolean,
			default: false
		},
		caption: {
			type: String,
			default: ''
		},
		sizeContentText: {
			type: String,
			default: 'small'
		},
		additionalStyleSectionContent: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			parenthesisTextWidth: 0,
			t: null,
			utils: utils
			// artifact: null
		}
	},
	computed: {
		...mapGetters(['isMobile']),
	},
	watch: {
		visible(n, o) {
			if(n && !o && this.isMobile) {
				// t.play();
			}
		}
	},
	methods: {
		createTimeline(duration, onComplete) {
			return gsap.timeline({
				defaults: {
					duration: duration,
					ease: Power1.easeInOut
				},
				...onComplete,
				paused: true
			});
		},
		setParenthesisItem() {
			this.parenthesisTextWidth = document.querySelector('#'+this.id+' .section-button-text').getBoundingClientRect().width
			document.querySelector('#'+this.id+' .section-button-text').style.width = 0+'px';
		},

		playAnimation() {
			
		},
		showInDepthEvent() {
			this.$emit('show-in-depth', this.id)
		}
	},
	mounted() {
		// this.setParenthesisItem();
		if(this.visible) {
			t.play();
		}
	}
}

</script>

<style lang="scss">

	@import '@css/variables.scss';
	
	.scroll-content-section {
		position: absolute;
		top: var(--total-bar-height);
		width: 100%;
		// padding: 20vh 10vw 10vh 10vw;
		background-color: transparent;
		height: calc(100% - var(--total-bar-height));
		justify-content: space-between;
		align-items: flex-start;
		z-index: 1;
		color: var(--scrolly-text-color);
	}

	.scroll-content-text {
		opacity: 0;
		// margin-top: 2rem;
		line-height: 160%;
		position: absolute;
		left: 0;
		top: 50%;
		transform: translate(0, 0);
		gap: var(--s4);
	}

	.scroll-content-text strong {
		font-weight: var(--font-medium);
	}

	.scroll-content-text {
		font-weight: var(--font-regular);
	}

	.scroll-content-text-video-button {
		gap: 4rem;
	}

	@media(max-width: $breakpoint-mlll) {
		.scroll-content-text-video-button {
			gap: 2rem;
		}

		.scroll-content-text {
			gap: 2rem;
			line-height: 140%;

	  	h2 {
	  		font-size: calc(2.9 * var(--base-font-size));
	  	}
		}
	} 

	@media(max-width: $breakpoint-ml) {
		.scroll-content-text-video-button {
			gap: 1.5rem;
		}

		.scroll-content-text {
			gap: 1rem;
		}
	} 
	
	
	@media (min-width: $breakpoint-sm + 1) {
		.scroll-content-text.large {
			width: 45vw;
		}

		.scroll-content-text.small {
			width: 32rem;
		}

		.scroll-content-text.normal {
			width: 37.5rem;
		}
	}

	@media (max-width: $breakpoint-sm) {

		.scrolly-section-mobile-cont .scroll-content-section {
			top: 0;
			position: relative;
		}

		.scrolly-section-mobile-cont .scroll-content-text {
			position: relative;
			top: 0;
			opacity: 0 !important;
			width: 100%;
			left: unset;
			top: unset;
			transform: translate(0, 4rem) !important;
			transition-property: opacity, transform;
			transition-duration: 0.5s;
			gap: 2rem;
		}

		 .scrolly-section-mobile-cont .scroll-content-text.visible {
			opacity: 1 !important;
			transform: translate(0, 0) !important;
		}

		.scroll-content-text h2 {
			font-size: calc(2.3 * var(--base-font-size));
		}
	}

	.scroll-content-section.left .scroll-content-text {
		transform: translate(var(--section-left-margin), -30%);
	}

	.scroll-content-section.right .scroll-content-text {
		transform: translate(calc(var(--scrolly-w) - var(--section-right-margin) - 100%), -30%);
	}
	
</style>
